import axios from 'axios';
import { api, headers } from '../../app/conf';
import { makeQuery } from '../../shared/helpers/commons';

export const getContacts = (filters, token) =>
    axios({
        method: 'get',
        url: `${api}/contacts?${makeQuery(filters)}`,
        headers: {
            ...headers,
            'X-Access-Token': token
        }
    });

export const postContacts = (data, token) =>
    axios({
        method: 'post',
        url: `${api}/contacts`,
        headers: {
            ...headers,
            'X-Access-Token': token,
            expireResponseWithKey: `${api}/contacts`
        },
        data: data
    });

export const putContacts = (data, token) =>
    axios({
        method: 'put',
        url: `${api}/contacts/${data.identifier}`,
        headers: {
            ...headers,
            'X-Access-Token': token,
            expireResponseWithKey: `${api}/contacts`
        },
        data: data
    });
